import { render, staticRenderFns } from "./PgaOfferEvaluationTotalCostsPostsaleDetails.vue?vue&type=template&id=4b81736c&"
import script from "./PgaOfferEvaluationTotalCostsPostsaleDetails.vue?vue&type=script&lang=ts&"
export * from "./PgaOfferEvaluationTotalCostsPostsaleDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b81736c')) {
      api.createRecord('4b81736c', component.options)
    } else {
      api.reload('4b81736c', component.options)
    }
    module.hot.accept("./PgaOfferEvaluationTotalCostsPostsaleDetails.vue?vue&type=template&id=4b81736c&", function () {
      api.rerender('4b81736c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/components/details/sub-components/PgaOfferEvaluationTotalCostsPostsaleDetails.vue"
export default component.exports